"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useConceptOfferHintSelections = void 0;
var _logger = require("@ori/logger");
var _react = require("react");
var _logger2 = require("../logger");
var _types = require("../types");
const MINIMUM_BENEFITS_LIMIT = 1;
const countSelectedQuantity = selectedItems => selectedItems.reduce((acc, {
  selectedQuantity
}) => acc + selectedQuantity, 0);
const useConceptOfferHintSelections = ({
  benefits,
  benefitsQuantity,
  items1stSection,
  isOfferApplicable,
  offerType,
  offerItems,
  requiredQuantity,
  resetAvailabilityChange,
  setOfferItems
}) => {
  const logger = (0, _logger.useLogger)('useConceptOfferHintSelections');
  const selectedItems1stSection = (0, _react.useMemo)(() => items1stSection.filter(({
    selectedQuantity
  }) => selectedQuantity > 0), [items1stSection]);
  const selectedFirstSectionItemsCount = (0, _react.useMemo)(() => countSelectedQuantity(selectedItems1stSection), [selectedItems1stSection]);
  const selectedBenefits = (0, _react.useMemo)(() => benefits.filter(({
    selectedQuantity
  }) => selectedQuantity > 0), [benefits]);
  const isRequirementMet = (0, _react.useMemo)(() => selectedFirstSectionItemsCount === requiredQuantity && isOfferApplicable(), [isOfferApplicable, requiredQuantity, selectedFirstSectionItemsCount]);
  const isBenefitsMaximumLimitMet = (0, _react.useMemo)(() => offerType === _types.BasketOfferTypes.CHOOSE_WITH_DISCOUNT ? countSelectedQuantity(selectedBenefits) === requiredQuantity : countSelectedQuantity(selectedBenefits) === benefitsQuantity, [benefitsQuantity, offerType, requiredQuantity, selectedBenefits]);
  const isBenefitsMinimumLimitMet = (0, _react.useMemo)(() => countSelectedQuantity(selectedBenefits) >= MINIMUM_BENEFITS_LIMIT, [selectedBenefits]);

  /**
   * This is the place where selection changes made by the user are propagated
   * into state. Selecting, deselecting item and quantity changes are all
   * solved via modifying the selectedQuantity now.
   */
  const setSelectedQuantity = (0, _react.useCallback)((itemCode, quantity, isBenefit = false) => {
    if (Number.isNaN(quantity)) {
      const error = new Error(`Wrong selected quantity value for item ${itemCode}: ${quantity}.`);
      logger.error(error);
      return;
    }
    const index = offerItems.findIndex(x => x.itemCode === itemCode && x.isBenefit === isBenefit);
    if (index < 0) {
      const error = new Error(`Couldn't find item ${itemCode}, benefit: ${isBenefit}.`);
      logger.error(error);
      return;
    }
    const item = offerItems[index];
    const {
      availableQuantity,
      purchasedQuantity,
      selectedQuantity: originalQuantity
    } = item;
    if (originalQuantity === quantity) {
      const error = new Error(`Item ${itemCode} already has selected quantity ${quantity}.`);
      logger.error(error);
      return;
    }
    if (quantity < 0) {
      const error = new Error(`Wrong selected quantity value for item ${itemCode}: ${quantity}.`);
      logger.error(error);
      return;
    }
    if (quantity < purchasedQuantity) {
      const error = new Error(`Can't set selected quantity below purchased quantity for item ${itemCode}.`);
      logger.error(error);
      return;
    }
    if (availableQuantity !== undefined && quantity > Number(availableQuantity)) {
      const error = new Error(`Can't set selected quantity above available quantity for item ${itemCode}.`);
      logger.error(error);
      return;
    }
    // updated item data
    const replacedItem = {
      ...item,
      selectedQuantity: quantity,
      wasAvailabilityChange: false
    };
    // with each user change, the previous availability highighting is removed
    const newState = resetAvailabilityChange([...offerItems]);
    newState.splice(index, 1, replacedItem);
    // do additional checks on new state copy - quantity limits
    const quantityLimit = offerType === _types.BasketOfferTypes.CHOOSE_WITH_DISCOUNT || !isBenefit ? requiredQuantity : benefitsQuantity;
    const checkedCollection = newState.filter(({
      isBenefit: isBenefitItem,
      selectedQuantity
    }) => isBenefit === isBenefitItem && selectedQuantity > 0);
    if (countSelectedQuantity(checkedCollection) > quantityLimit) {
      const error = new Error(`Change not applied due to quantity limit ${quantityLimit}.`);
      logger.error(error);
      return;
    }
    (0, _logger2.logDebug)(`Changing item ${itemCode} quantity to ${quantity}. Benefit: ${isBenefit}. New selection state`, newState);
    setOfferItems(newState);
  }, [benefitsQuantity, logger, offerItems, offerType, requiredQuantity, resetAvailabilityChange, setOfferItems]);
  return {
    isBenefitsMaximumLimitMet,
    isBenefitsMinimumLimitMet,
    isRequirementMet,
    selectedBenefits,
    selectedItems1stSection,
    selectedFirstSectionItemsCount,
    setSelectedQuantity
  };
};
exports.useConceptOfferHintSelections = useConceptOfferHintSelections;